import { BaseResource } from '../core/base-resource';

export class SizeUpsell extends BaseResource {
  priceDiff: number;
  size: string;
  sizeLabel: string;
  title: string;
  subtitle: string;
}
